export default __webpack_public_path__ + "static/media/ST1_Grand_stretch.5263f7b5.png";